import React, { useEffect, useState } from 'react';

import GridItem from 'components/Grid/GridItem.js';
import GridContainer from 'components/Grid/GridContainer.js';
import Card from 'components/Card/Card.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardBody from 'components/Card/CardBody.js';
import { Assignment } from '@material-ui/icons';
import { FormControl, InputLabel, MenuItem, Select, TextField } from '@material-ui/core';
import { nDecimal } from 'hooks/Pipe';
import { wsGetAll } from 'services/WService';

export default function WriteSaleData(props) {
  const { inputChange, dataProduct } = props; //data Products

  const [measureUnits, setMeasureUnits] = useState([]);
  const [lengthUnits, setLengthUnits] = useState([]);
  const [taxs, setTaxs] = useState([]);

  async function listMeasureUnits() {
    let response = await wsGetAll('logi/measure-unit');
    if (response.success) setMeasureUnits(response.data);
  }

  async function listLengthUnits() {
    let response = await wsGetAll('logi/length-unit');
    if (response.success) setLengthUnits(response.data);
  }

  async function listTaxs() {
    let response = await wsGetAll('base/tax');
    if (response.success) setTaxs(response.data);
  }

  useEffect(() => {
    listMeasureUnits();
    listLengthUnits();
    listTaxs();
  }, []);

  return (
    <>
      <GridItem xs={12} sm={12} md={6}>
        <Card>
          <CardHeader icon>
            <CardIcon color="primary">
              <Assignment />
            </CardIcon>
            <h4 style={{ color: 'black' }}>Artículo venta</h4>
          </CardHeader>

          <CardBody>
            <GridContainer>
              <GridItem xs={12} md={12} xl={3}>
                <FormControl fullWidth margin="normal" size="small">
                  <InputLabel>U.M venta</InputLabel>
                  <Select
                    value={dataProduct.logi_measure_unit_id_SalUnitMsr || ''}
                    required
                    inputProps={{
                      name: 'logi_measure_unit_id_SalUnitMsr',
                      onChange: inputChange
                    }}
                  >
                    {measureUnits.map((item) => {
                      return (
                        <MenuItem key={item.id} value={item.id}>
                          {item.UgpName}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </GridItem>
              <GridItem xs={12} md={12} xl={3}>
                <TextField
                  label="Unidades venta"
                  name="NumInSale"
                  value={nDecimal(dataProduct.NumInSale)}
                  inputProps={{ onChange: inputChange, min: 0.01 }}
                  type="number"
                  margin="normal"
                  fullWidth
                />
              </GridItem>
              <GridItem xs={12} md={12} xl={3}>
                <FormControl fullWidth margin="normal" size="small">
                  <InputLabel>Indicador impuesto</InputLabel>
                  <Select
                    value={dataProduct.base_tax_id_AR || ''}
                    inputProps={{
                      name: 'base_tax_id_AR',
                      onChange: inputChange
                    }}
                  >
                    {taxs.map((item) => {
                      return (
                        <MenuItem key={item.id} value={item.id}>
                          {item.Code}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </GridItem>
              <GridItem xs={12} md={12} xl={3}>
                <FormControl fullWidth margin="normal" size="small">
                  <InputLabel>U.M de Empaque</InputLabel>
                  <Select
                    value={dataProduct.logi_measure_unit_id_SalPackMsr || ''}
                    inputProps={{
                      name: 'logi_measure_unit_id_SalPackMsr',
                      onChange: inputChange
                    }}
                  >
                    {measureUnits.map((item) => {
                      return (
                        <MenuItem key={item.id} value={item.id}>
                          {item.UgpName}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={12} md={6}>
        <Card>
          <CardHeader icon>
            <CardIcon color="primary">
              <Assignment />
            </CardIcon>
            <h4 style={{ color: 'black' }}>Medidas</h4>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12} lg={6} xl={4}>
                <TextField
                  label="Logintud"
                  name="SLength1"
                  value={nDecimal(dataProduct.SLength1)}
                  inputProps={{ onChange: inputChange, min: 0.01 }}
                  type="number"
                  margin="normal"
                  fullWidth
                />
              </GridItem>
              <GridItem xs={12} lg={6} xl={4}>
                <TextField
                  label="Ancho"
                  name="SWidth1"
                  value={nDecimal(dataProduct.SWidth1)}
                  inputProps={{ onChange: inputChange, min: 0.01 }}
                  type="number"
                  margin="normal"
                  fullWidth
                />
              </GridItem>
              <GridItem xs={12} lg={6} xl={4}>
                <TextField
                  label="Altura"
                  name="SHeight1"
                  value={nDecimal(dataProduct.SHeight1)}
                  inputProps={{ onChange: inputChange, min: 0.01 }}
                  type="number"
                  margin="normal"
                  fullWidth
                />
              </GridItem>
              <GridItem xs={12} lg={6} xl={4}>
                <FormControl fullWidth margin="normal" size="small">
                  <InputLabel>Unid. de volumen</InputLabel>
                  <Select
                    value={dataProduct.logi_length_unit_id_SVolUnit || ''}
                    inputProps={{
                      name: 'logi_length_unit_id_SVolUnit',
                      onChange: inputChange
                    }}
                  >
                    {lengthUnits.map((item) => {
                      return (
                        <MenuItem key={item.id} value={item.id}>
                          {item.UnitName}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </GridItem>
              <GridItem xs={12} lg={6} xl={4}>
                <TextField
                  label="Volumen"
                  name="SVolume"
                  value={nDecimal(dataProduct.SVolume)}
                  inputProps={{ onChange: inputChange, min: 0.01 }}
                  type="number"
                  margin="normal"
                  fullWidth
                />
              </GridItem>
              <GridItem xs={12} lg={6} xl={4}>
                <TextField
                  label="Peso"
                  name="SWeight1"
                  value={nDecimal(dataProduct.SWeight1)}
                  inputProps={{ onChange: inputChange, min: 0.01 }}
                  type="number"
                  margin="normal"
                  fullWidth
                />
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      </GridItem>
    </>
  );
}
